/**
 * @file ImageWrapper/component.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 */

import { arrayOf, string, number } from "prop-types";
import { Image } from "../Image/component";
import { usePreviewBase } from "../../hooks/usePreviewBase";
import { useImageDerivatives } from "../../hooks/useImageDerivatives";

const ImageWrapper = ({
    url = "",
    derivativeWidths = [],
    sizesRatio,
    loading,
    sizes,
    ...props
}) => {
    const imageUrl = usePreviewBase(url);

    const [derivativeSrcSet, derivativeSizes] = useImageDerivatives(
        imageUrl,
        derivativeWidths,
        sizesRatio,
        props.useoriginalimage
    );

    return (
        <Image
            url={imageUrl}
            sizes={sizes || derivativeSizes}
            srcSet={derivativeSrcSet}
            loading={loading}
            type={props.type}
            {...props}
        />
    );
};

ImageWrapper.propTypes = {
    url: string,
    derivativeWidths: arrayOf(number),
    sizesRatio: string,
    loading: string,
};

export default ImageWrapper;
